// ScrollToTop.js - Güncellenmiş versiyon
import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Tüm navigasyon türlerinde ve pathname değişiminde en üste çık
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // Daha yumuşak geçiş
    });
  }, [pathname]); // navigationType'ı kaldırıp sadece pathname'i izle

  return null;
}
